import { lazy } from 'react'

export const BlackListPartnerLazy = lazy(() => import('Pages/pp/blackListPartner/components/Grid'))
